"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Help;

var _Help = require("@adobe/react-spectrum-workflow/dist/Help");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function Help(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Help.A4uHelp, null));
}